/**
 * Canonical list of Frontegg feature entitlement keys that apps/extensions
 * can declare and receive through the bridge.
 *
 * Internal-only keys (e.g. BetaAccessFull, UnpublishedManifests) live
 * in api-core's extensions-registry enum, which extends this shared set.
 */
export enum FronteggExtensionsFeatureKeys {
  ProPlan = 'pro-plan-feature',
  /** @deprecated Remove once all apps have been migrated off features_required: ['premium-feature'] (PROD-7141). */
  PremiumPlan = 'premium-feature',
  AppsCbtActivities = 'apps-cbt-activities',
  AppsDialInBeta = 'apps-dial-in-beta',
  AppsMeetRedirectBeta = 'apps-meet-redirect-beta',
  AppsIssueReportBeta = 'apps-issue-report-beta',
  AppsSchedulerBeta = 'apps-scheduler-beta',
  AppsInAppAnnouncementsBeta = 'apps-in-app-announcements-beta',
  AppsReference = 'apps-reference',
  AppsEmdr = 'apps-emdr',
  AppsPayment = 'apps-payment',
  AppsAgenda = 'apps-agenda',
  AppsAssessments = 'apps-assessments',
  AppsFileTransfer = 'apps-file-transfer',
  AppsPhotoCapture = 'apps-photo-capture',
  AppsBundleFileTransferPhotoCapture = 'apps-bundle-file-transfer-photo-capture',
  AppsFax = 'apps-fax',
  AppsGames = 'apps-games',
  AppsInterpreter = 'apps-interpreter',
  AppsRecord = 'apps-record',
  AppsTeleconsent = 'apps-teleconsent',
  AppsTranscript = 'apps-transcript',
  AppsWhiteboard = 'apps-whiteboard',
  AppsTimer = 'apps-timer',
  AppsNotepad = 'apps-notepad',
  AppsScribe = 'apps-scribe',
}

/**
 * Canonical list of app-level permissions granted to users via Frontegg.
 */
export enum FronteggExtensionsPermissionKeys {
  AppUser = 'app-user',
  AppAdmin = 'app-admin',
  AppOwner = 'app-owner',
}
